import { createSelector } from 'reselect'
import entities from 'entities'

const selectSpecs = state => state.specs

const selectPhoneInfo = createSelector(
  selectSpecs,
  specs => {
    let phone = specs.currentPhoneInfo.phone
    return phone
      ? {
        ...specs.currentPhoneInfo,
        phone: {
          ...phone,
          name_pretty: `${phone.manufacturer} ${
            phone.vanity_name
              ? entities.decodeHTML(phone.vanity_name) +
                  ' (' +
                  phone.name +
                  ')'
              : phone.name
          }`
        }
      }
      : {}
  }
)

const selectParentPhoneId = createSelector(
  selectPhoneInfo,
  phoneInfo =>
    phoneInfo.phone &&
    (Array.isArray(phoneInfo.phone.parentfk) ? '' : phoneInfo.phone.parentfk)
)

const selectSwimlaneTutorials = createSelector(
  selectSpecs,
  specs =>
    specs.swimlanecontent.filter(content => content.contentType === 'tutorial')
)

const selectSwimlaneFAQs = createSelector(
  selectSpecs,
  specs =>
    specs.swimlanecontent.filter(content => content.contentType === 'faq')
)

const selectSwimlaneGuides = createSelector(
  selectSpecs,
  specs =>
    specs.swimlanecontent.filter(content => content.contentType === 'guide')
)

const selectSwimlaneVideos = createSelector(
  selectSpecs,
  specs =>
    specs.swimlanecontent.filter(content => content.contentType === 'video')
)

const selectSwimlaneFetching = createSelector(
  selectSpecs,
  specs => specs.isFetching
)

const selectCurrentPhoneSpecsId = createSelector(
  selectSpecs,
  specs => specs.currentPhoneId
)

export {
  selectPhoneInfo,
  selectSwimlaneTutorials,
  selectSwimlaneFAQs,
  selectSwimlaneGuides,
  selectSwimlaneVideos,
  selectSwimlaneFetching,
  selectCurrentPhoneSpecsId,
  selectParentPhoneId
}



// WEBPACK FOOTER //
// ./src/containers/Specs/selectors.js